import { BaseEvent, EventCategory, EventProperties } from '@lendi/analytics-web';

import { lendiAnalytics } from './analytics';
import { eventTracking } from './base';

// Toggle event
const TOGGLE_SWITCH_CHANGE = 'Toggle Switch Changed';
interface ToggleEvent extends EventProperties, BaseEvent {
  event_name: typeof TOGGLE_SWITCH_CHANGE;
  title: string;
  text: string;
  value: boolean;
  position: string;
}
export function toggleEventTracking(
  analytics: ReturnType<typeof lendiAnalytics>,
  props: Pick<ToggleEvent, 'title' | 'text' | 'value' | 'position'>
) {
  eventTracking<ToggleEvent>(analytics, {
    ...props,
    event_name: TOGGLE_SWITCH_CHANGE,
    category: EventCategory.FUNNELS,
  });
}
